<script setup lang="ts">
import { Tooltip, TooltipContent, TooltipTrigger } from '@forgd/ui-kit/tooltip'
import { QuestionMarkCircleIcon } from '@heroicons/vue/24/outline'

withDefaults(defineProps<{
  value: number | string
  title: string
  tooltip?: string
  size?: 'md' | 'lg'
}>(), {
  size: 'lg',
})
</script>

<template>
  <div data-el="DtStatCounter" class="flex flex-col items-center" :class="size === 'md' ? 'gap-1' : 'gap-2'">
    <div class="font-sans text-xs leading-4 text-gray-600">
      {{ title }}
    </div>
    <div
      class="flex items-center gap-1 leading-none font-semibold tracking-tight text-primal"
      :class="size === 'md' ? 'text-xl' : 'text-2xl'"
    >
      {{ value }}
      <Tooltip v-if="tooltip">
        <TooltipTrigger type="button" :aria-label="tooltip" class="inline-flex">
          <QuestionMarkCircleIcon class="size-4 shrink-0 text-primary-300" aria-hidden="true" />
        </TooltipTrigger>
        <TooltipContent>{{ tooltip }}</TooltipContent>
      </Tooltip>
    </div>
  </div>
</template>
